import { DefaultTheme } from 'styled-components'

export const theme: DefaultTheme = {
  white: '#fff',
  lightBlue: '#29ABE2',
  darkBlue: '#2973E2',
  titleBlue: '#2980E2',
  grey: '#646464'
}
